import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CheckoutRequestAttributes } from '../../objects/checkout-request';
import { Order } from '../../objects/order';
import { Transaction } from '../../objects/transaction';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionService extends BaseService {
  createInstance = (transaction: Transaction) => transaction;

  get(order: Order, transaction: Transaction): Observable<Transaction> {
    const endpoint = `orders/${order.id}/transactions/${transaction.id}`;

    return super.doGet(endpoint);
  }

  create(order: Order, request: CheckoutRequestAttributes): Observable<Transaction> {
    const endpoint = `orders/${order.id}/transactions`;

    return super.doCreate(request, endpoint);
  }
}
